import { TReduxActions } from '../../../types/redux';
import { ENameActionTypes } from '../../../actions/newQuestion/nameActions';
import { ENewQuestionForm } from '../../../actions/newQuestion';

export const defaultValue = null;

export function nameReducer(state: string | null = defaultValue, { type, payload }: TReduxActions): string | null {
  if (type === ENameActionTypes.SetName) {
    return payload;
  }

  if (type === ENewQuestionForm.Clear) {
    return defaultValue;
  }

  return state;
}
